import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IActivateJobsData {
  ids: Array<number>;
}

const activateJobs = (postData: IActivateJobsData) => {
  return http().post(endpoints.job.activateJobs, postData);
};

export function useActivateJobs() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activateJobs,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchTabItemCountByModule', 'job'] });
      }
    },
  });
}
